import React, { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { getTextHoverMic } from 'flow/utils/meeting-utils';
import { toggleSenderMeetingAudioActive } from 'flow/actions/meeting-actions';
import {
    selectSenderAudioActive,
    selectMicAllowed,
} from 'flow/selectors/meeting-selectors';
import MeetingButton from 'flow/components/meeting/MeetingButton';

export const ButtonToggleMicrophone = () => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    const audioActive = useAppSelector(selectSenderAudioActive);
    const micIsAllowed = useAppSelector(selectMicAllowed);

    const toggleAudioActive = useCallback(() => {
        dispatch(toggleSenderMeetingAudioActive());
    }, [dispatch]);

    return (
        <div
            className="flex flex-col items-center justify-center text-xs select-none"
            data-test-id={'meeting-mic-button'}
        >
            <MeetingButton
                iconType={audioActive ? 'mic_outlined' : 'mic_off'}
                active={!audioActive}
                callback={micIsAllowed ? toggleAudioActive : () => {}}
                hoverText={getTextHoverMic(audioActive, i18next)}
                disabled={!micIsAllowed}
            />
        </div>
    );
};

export default ButtonToggleMicrophone;
